import { ActiveLanguage } from 'shared/vidio_helpers';

export default class DateTimeHelper {
  static formatDateTime(dateTime, lang) {
    let date = new Date(dateTime);
    let day = DateTimeHelper.dayNames[lang][date.getDay()];
    let month = DateTimeHelper.monthNames[lang][date.getMonth()];
    let hour = DateTimeHelper.padedTime(date.getHours());
    let minute = DateTimeHelper.padedTime(date.getMinutes());

    return `${day}, ${date.getDate()} ${month} ${date.getFullYear()}・${hour}:${minute}`;
  }

  static formatRemainingDay(liveDate) {
    const MS_PER_DAY = 24 * 60 * 60 * 1000;
    let todayDate = DateTimeHelper.now();
    let liveDateUtc = Date.UTC(liveDate.getFullYear(), liveDate.getMonth(), liveDate.getDate());
    let todayDateUtc = Date.UTC(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate());
    let remainingDay = Math.floor((liveDateUtc - todayDateUtc) / MS_PER_DAY);
    let dayLang = DateTimeHelper.getDayLanguage(remainingDay);

    return remainingDay + ' ' + dayLang;
  }

  static getDayLanguage(remainingDay) {
    let lang = ActiveLanguage.get();
    let day = window.Locale[lang].livestreaming.countdown_day;

    return DateTimeHelper.pluralize(lang, remainingDay, day);
  }

  static formatRemainingTime(remainingTime) {
    let lang = ActiveLanguage.get();
    let hour = DateTimeHelper.hourLocale[lang];
    let minute = DateTimeHelper.minuteLocale[lang];
    let second = DateTimeHelper.secondLocale[lang];

    if (remainingTime <= 0) {
      return `00 ${hour} : 00 ${minute} : 00 ${second}`;
    }

    let remainingHour = Math.floor(remainingTime / 3600);
    let remainingMinute = Math.floor((remainingTime - remainingHour * 3600) / 60);
    let remainingSecond = Math.floor(remainingTime - remainingHour * 3600 - remainingMinute * 60)

    hour = DateTimeHelper.pluralize(lang, remainingHour, hour);
    minute = DateTimeHelper.pluralize(lang, remainingMinute, minute);
    second = DateTimeHelper.pluralize(lang, remainingSecond, second);

    if (remainingMinute === 60) {
      remainingMinute = 59;
    }

    return `${DateTimeHelper.padedTime(remainingHour)} ${hour} : ${DateTimeHelper.padedTime(remainingMinute)} ${minute} : ${DateTimeHelper.padedTime(remainingSecond)} ${second}`;
  }

  static padedTime(value) {
    if (value <= 0) {
      return '00';
    }
    if (value < 10) {
      return '0' + value;
    }
    return '' + value;
  };

  static now() {
    return new Date(Date.now());
  }

  static get monthNames() {
    return {
      en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      id: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
    };
  }

  static get dayNames() {
    return {
      en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      id: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
    };
  }

  static get hourLocale() {
    return {
      en: 'hour',
      id: 'jam'
    };
  }

  static get minuteLocale() {
    return {
      en: 'minute',
      id: 'menit'
    };
  }

  static get secondLocale() {
    return {
      en: 'second',
      id: 'detik'
    };
  }


  static pluralize(lang, remaining, word) {
    if (lang == 'en' && remaining > 1) {
      return word + 's';
    }
    return word;
  }
};
